import Link from 'found/Link';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { NavItem } from 'reactstrap';

import BareNavigation from 'src/components/Navigation/BareNavigation';
import { APIConfig } from 'src/config';

/**
 * Description
 * @returns {React.ReactComponentElement} - AnonymousNavigation component
 */
function AnonymousNavigation() {
  const apiConfig = APIConfig();
  const cobrand = apiConfig.cobrand();
  const primaryBrand = apiConfig.primaryBrand();

  return (
    <BareNavigation cobrand={cobrand} primaryBrand={primaryBrand}>
      <NavItem>
        <Link to="/login" className="nav-link">
          <FormattedMessage id="navigation.anonymous_navigation.login.link" defaultMessage="Log in" />
        </Link>
      </NavItem>
    </BareNavigation>
  );
}

export default AnonymousNavigation;
